import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { NewRequestComponent } from './new-request/new-request.component';
import { MyTeamRequestComponent } from './my-team-request/my-team-request.component';
import { TeamRequestsToApproveComponent } from './team-requests-to-approve/team-requests-to-approve.component';

import { AuthenticationProvider } from './core/providers/authentication.provider';
import { HttpLoaderInterceptor } from './core/interceptors/http-loader-interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AccessDeniedComponent } from './access-denied/access-denied.component';


export function authenticationProviderFactory(provider: AuthenticationProvider) {
  return () => provider.getCurrentUser();
}


@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    NewRequestComponent,
    MyTeamRequestComponent,
    TeamRequestsToApproveComponent,
    AccessDeniedComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    GridModule,
    DialogsModule,
    NotificationModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'new-request', component: NewRequestComponent },
      { path: 'my-team-request', component: MyTeamRequestComponent },
      { path: 'team-requests-to-approve', component: TeamRequestsToApproveComponent },
      { path: 'access-denied', component: AccessDeniedComponent },
    ]),
    NgxSpinnerModule,
    InputsModule,
    BrowserAnimationsModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authenticationProviderFactory,
      deps: [AuthenticationProvider],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
